import React from "react";
import { useNavigate } from "react-router-dom";
import "../minime-theme.css";
import "./MiniMeHome.css";
import ModalStatusLed from "../components/ModalStatusLed";
import TopStatusPills from "../components/TopStatusPills";
import { SERVER_URL } from "../../../../config/serverUrl";

const serverUrl = SERVER_URL;

const MiniMeHomePage = () => {
  const navigate = useNavigate();
  const eventName = window.location.pathname.split("/")[1];

  const handleStartCapture = () => {
    navigate(`/${eventName}/capture`);
  };

  return (
    <>
      <ModalStatusLed serverUrl={serverUrl} />
      <TopStatusPills serverUrl={serverUrl} eventName={eventName} />
      <div className="minime-home-container">
        <div className="minime-home-content">
          <h1 className="minime-home-title">MiniMe</h1>
          <p className="minime-home-welcome">ברוכים הבאים לאטרקציית MiniMe</p>
          <button
            className="minime-start-button"
            onClick={handleStartCapture}
          >
            התחל
          </button>
        </div>
      </div>
    </>
  );
};

export default MiniMeHomePage;
